import { FC, useState, useEffect, ReactElement } from 'react';
import IconButton from 'src/components/atoms/buttons/IconButton';
import './style.scss';

interface Props {
  id?: string;
  label: string;
  desc?: string;
  content: ReactElement;
  type?: string;
  vtype?: string;
  contentView?: boolean;
  foldBtn?: boolean;
  foldBtnText?: any;
  foldBtnClickEvent?: (id: string, status: string) => void;
  editClickEvt?: (type: string) => void;
  styleDef?: React.CSSProperties;
}

const TitleContent: FC<Props> = ({
  id = '',
  content,
  label,
  desc,
  styleDef,
  type,
  vtype,
  contentView = true,
  foldBtn,
  foldBtnText = [],
  foldBtnClickEvent,
  editClickEvt,
}) => {
  const [viewState, setViewState] = useState({ active: contentView ? '_active' : '' });
  const [editTypeState, setEditTypeState] = useState({ type: '' });

  useEffect(() => {
    contentView ? setViewState({ active: '_active' }) : setViewState({ active: '' });
  }, [contentView]);

  const viewContent = () => {
    viewState.active === '' ? setViewState({ active: '_active' }) : setViewState({ active: '' });
    if (foldBtnClickEvent) foldBtnClickEvent(id, viewState.active);
  };
  const editContent = () => {
    if (editClickEvt) editClickEvt('edit');
    setEditTypeState({ type: 'edit' });
  };
  const confirmContent = () => {
    if (editClickEvt) editClickEvt('save');
    setEditTypeState({ type: '' });
  };
  const cancleContent = () => {
    if (editClickEvt) editClickEvt('cancle');
    setEditTypeState({ type: '' });
  };

  return (
    <div className={['_title_content_box_layout', vtype].join(' ')}>
      {label !== '' ? (
        <div className="_label_div">
          <div className="_label _ft_tt_t1">{label}</div>
          {foldBtn ? (
            <div className="_fold">
              {foldBtnText.length > 0 ? (
                <div
                  className={viewState.active === '' ? '_btn_div _text' : '_btn_div _text _d_btn'}
                  onClick={viewContent}
                >
                  <div className="_btn"></div>
                  <div className="_text">
                    {viewState.active === '' ? foldBtnText[0] : foldBtnText[1]}
                  </div>
                </div>
              ) : (
                <div
                  className={viewState.active === '' ? '_btn_div' : '_btn_div _d_btn'}
                  onClick={viewContent}
                >
                  <div className="_btn"></div>
                </div>
              )}
            </div>
          ) : (
            ''
          )}
          {editClickEvt ? (
            <div className="_edit_btn_div">
              {editTypeState.type !== 'edit' ? (
                <div className="_edit_div">
                  <div className="_btn">
                    <IconButton
                      icon="ri-edit-box-line"
                      clickEvent={editContent}
                      type="type2"
                      styleDef={{
                        width: '28px',
                        height: '28px',
                        fontSize: '16px',
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div className="_edit_div">
                  <div className="_btn">
                    <IconButton
                      icon="ri-save-3-line"
                      clickEvent={confirmContent}
                      type="type2"
                      styleDef={{
                        width: '28px',
                        height: '28px',
                        fontSize: '16px',
                      }}
                    />
                  </div>
                  <div className="_btn">
                    <IconButton
                      icon="ri-close-large-line"
                      clickEvent={cancleContent}
                      type="type3"
                      styleDef={{
                        width: '28px',
                        height: '28px',
                        fontSize: '16px',
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}

      {desc ? <div className="_label_desc _ft_ct_t3">{desc}</div> : ''}
      <div className={['_content_div', viewState.active].join(' ')} style={styleDef}>
        <div className={['_content', type].join(' ')}>{content}</div>
      </div>
    </div>
  );
};

export default TitleContent;
